import React from "react";
import Skeleton from "react-loading-skeleton";
import { View } from "react-native";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import Skeletons from "./Skeletons";
import { AppColors } from "../../utility/AppColors";
import { s } from "react-native-size-matters";

const GameSkeleton = () => {
  const deviceSize = useDeviceSize();
  let gameCards = Array(14).fill(0);
  return (
    <View
      style={{
        flexDirection: "column",
        width: "50%",
        gap: 10,
        paddingTop: 12,
        paddingBottom: 35,
      }}
    >
      <View
        style={{
          flexDirection: "row",
          width: "50%",
          gap: 25,
        }}
      >
        {gameCards.map((index) => (
          <View
            key={index}
            style={{
              flexDirection: "column",
              gap: 6.78,
              alignItems: "center",
            }}
          >
            <Skeletons
              height={128}
              width={"110px"}
              style={{
                borderRadius: 10,
                marginTop: 6,
              }}
            />
            <Skeletons
              height={20}
              width={"70px"}
              style={{
                borderRadius: 10,
                marginTop: 6,
              }}
            />
          </View>
        ))}
      </View>
    </View>
  );
};

export default GameSkeleton;
